import { IRouteConfig } from 'helpers/route-config';
import { createElement } from 'react';
import DrivingExemptions from './DrivingExemptions';
import GnhDrivingExemptionForm from './GnhDrivingExemptionForm';
import DrivingExemptionUserList from "./DrivingExemptionUserList";
import LVCommuteExemptionForm from './LvCommuteExemptionForm';
import DrivingExemptionDashboardOverview from './DrivingExemptionDashboardOverview';
import DrivingExemptionDetails from './DrivingExemptionDetails';
import GnhOnBehalfForm from './GnhOnBehalfForm';
// Pages
const drivingExemptionPath = "/drivingExemption";
export const dashboardOverview = 'overview';

const drivingExemptionBlankFormPath = `${drivingExemptionPath}/gnhform`;
const drivingExemptionUserListFormPath = `${drivingExemptionPath}/drivingexemptionuserlist`;
const drivingExemptionAdminListFormPath = `${drivingExemptionPath}/DrivingExemptionDashboard`;
const lvCommuteExemptionBlankFormPath = `${drivingExemptionPath}/lvform`;
const drivingExemptionDetailsPath = `${drivingExemptionPath}/details`;
const drivingExemptionDetailsTypePath = `${drivingExemptionPath}/details/:dashboardType`;
const drivingExemptionOverviewPath = `${drivingExemptionPath}/${dashboardOverview}`;  
const drivingExemptionOnBehalfPath = `${drivingExemptionPath}/onbehalf`;

// Routes
export const drivingExemptionRoute = {
    breadCrumb: "Driving Exemption",
    path: drivingExemptionPath,
    element: createElement(DrivingExemptionUserList),
} as IRouteConfig;

export const gnhDrivingExemptionBlankFormRoute = {
    breadCrumb: "GNH Driving Exemption Form",
    path: drivingExemptionBlankFormPath,
    element: createElement(GnhDrivingExemptionForm),
    endTrail: true
} as IRouteConfig;

export const gnhUsersSubmittedFormListRoute = {
    breadCrumb: "My Exemption",
    path: drivingExemptionUserListFormPath,
    element: createElement(DrivingExemptionUserList),
    endTrail: true
} as IRouteConfig;

export const lvCommuteExemptionBlankFormRoute = {
    breadCrumb: "LV Commute Exemption Form",
    path: lvCommuteExemptionBlankFormPath,
    element: createElement(LVCommuteExemptionForm),
    endTrail: true
} as IRouteConfig;

export const drivingExemptionOverviewPathRoute = {
    breadCrumb: "Exemptions Dashboard",
    permission: "web.admin.gnh-exemption.exemption-request-dashboard",
    path: drivingExemptionOverviewPath,
    element: createElement(DrivingExemptionDashboardOverview),
} as IRouteConfig;

export const drivingExemptionDetailsPathRoute = {
    breadCrumb: "User Details",
    path: drivingExemptionDetailsTypePath,
    element: createElement(DrivingExemptionDetails),
} as IRouteConfig;

export const drivingExemptionOnBehalfRoute = {
    breadCrumb: "On-behalf form",
   // permission: "web.admin.fatigue-assessment.on-behalf",
    path: drivingExemptionOnBehalfPath,
    element: createElement(GnhOnBehalfForm),
    endTrail: true
} as IRouteConfig;